<template>
  <header
    class="w-full bg-white py-6 px-8 sm:px-32 z-20 flex items-center justify-between sticky top-0 shadow-header"
  >
    <div id="header-breadcrumbs" class="shrink-0"></div>
    <nav class="flex w-full h-full items-center gap-5 justify-between">
      <slot name="before-links" />
      <img class="md:h-[32px] h-6" src="/images/logo/logoLong.svg" alt="USAT" />
      <ul class="flex gap-x-2">
        <li v-for="(link, index) in links" :key="index">
          <RouterLink
            :class="{ 'bg-gray-200 !text-blue-500': link.to === activeRoute }"
            :to="link.to"
            class="text-slate-700 px-3 py-2 inline-block text-sm transition-all duration-200 hover:bg-gray-200 rounded-md"
          >
            <span>{{ link.title }}</span>
          </RouterLink>
        </li>
      </ul>

      <div class="flex items-center divide-[#F6F8FA]">
        <CommonLanguageSwitcher class="pr-4 !my-0" />
        <!--        <Notifications v-if="authStore.hasUser" class="px-4" />-->

        <Transition name="fade" mode="out-in">
          <div v-if="!loading">
            <BaseAvatarCard
              :avatar="avatar"
              :name="profileData?.fullName"
              :role="profileData?.role ? profileData?.role : $t('student')"
              @logout="exitModal = true"
            />
          </div>
          <div
            v-else
            class="shimmer md:h-[47px] h-[45px] w-[47px] rounded-full md:rounded-xl md:w-[150px]"
          ></div>
        </Transition>
      </div>
    </nav>
  </header>
  <ExitModal v-model="exitModal" />
</template>
<script lang="ts" setup>
import type { IAuthUser } from "@/types/auth";
import { CommonLanguageSwitcher } from "@/components/Common";
import BaseAvatarCard from "@/components/Base/Avatar/BaseAvatarCard.vue";
import { usePersonalInfoStore } from "@/modules/Profile/personalInfoStore";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import ExitModal from "@/modules/Profile/components/PersonalInfo/ExitModal.vue";

const personalInfoStore = usePersonalInfoStore();
personalInfoStore.fetchProfileData();

interface Props {
  links?: { title: string; to: string }[];
  user?: IAuthUser;
  activeRoute?: string;
}

const { isLoading: loading, getProfileData: profileData } =
  storeToRefs(personalInfoStore);

defineProps<Props>();

interface Emits {
  (event: "logout"): void;
}

defineEmits<Emits>();

const { avatar } = storeToRefs(usePersonalInfoStore());
const exitModal = ref(false);
</script>
